var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPauseRegular = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.74609 3C4.7796 3 3.99609 3.7835 3.99609 4.75V19.25C3.99609 20.2165 4.7796 21 5.74609 21H9.24609C10.2126 21 10.9961 20.2165 10.9961 19.25V4.75C10.9961 3.7835 10.2126 3 9.24609 3H5.74609ZM5.49609 4.75C5.49609 4.61193 5.60802 4.5 5.74609 4.5H9.24609C9.38416 4.5 9.49609 4.61193 9.49609 4.75V19.25C9.49609 19.3881 9.38416 19.5 9.24609 19.5H5.74609C5.60802 19.5 5.49609 19.3881 5.49609 19.25V4.75ZM14.7461 3C13.7796 3 12.9961 3.7835 12.9961 4.75V19.25C12.9961 20.2165 13.7796 21 14.7461 21H18.2461C19.2126 21 19.9961 20.2165 19.9961 19.25V4.75C19.9961 3.7835 19.2126 3 18.2461 3H14.7461ZM14.4961 4.75C14.4961 4.61193 14.608 4.5 14.7461 4.5H18.2461C18.3842 4.5 18.4961 4.61193 18.4961 4.75V19.25C18.4961 19.3881 18.3842 19.5 18.2461 19.5H14.7461C14.608 19.5 14.4961 19.3881 14.4961 19.25V4.75Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPauseRegular, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pause-regular.7c3d9d03.svg";
export { ForwardRef as ReactComponent };